import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { HeaderAuthComponent } from '../../shared/components/header_auth/header_auth.component';
import { DeclaracionesPresentadasReteICAComponent } from '../declaraciones_presentadas_reteica/declaraciones_presentadas_reteica.component';

declare let gtag: Function;

@Component({
  selector: 'app-principal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HeaderAuthComponent, DeclaracionesPresentadasReteICAComponent],
  templateUrl: './retencionica.component.html',
  styleUrl: './retencionica.component.scss'
})

export class RetencionICAComponent implements OnInit {

  showViewHTMLComponent = false;
  listActividades = [];
  tabs = [true];

  constructor(private router: Router,
    private authService: AuthService) {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {
      this.showViewHTMLComponent = true;
    }
  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/retencion_ica' });
      } catch (err) {}
    }
  }

  changeTab(item: number){
    this.tabs[0] = false;
    this.tabs[0] = true; 
  }
}
